import slick from 'slick-carousel';

/**
 *  @constructor
 */
class TopSlider {
  constructor() {
    this.slide01;
    this.slide02;
    this.breakpoints = 750;
    this.ww = window.innerWidth;
  }
  /**
   * /ir/トップスライダー
   */
  init() {
    $('.m-circleBtn.next').on('click',()=>{
      this.slide01.slick('slickNext');
    })
    $('.m-circleBtn.prev').on('click',()=>{
      this.slide01.slick('slickPrev');
    })
    $(window).on('resize load',()=>{
      this.ww =window.innerWidth;
      this.swiperInit();
    })

  }
  swiperInit(){
    this.createSwiper01();
    this.createSlide02();
  }
  createSwiper01(){
    const self = this;
    this.slide01 = $('.p-topKvSlide__wrap').slick({
      autoplay: true,
      speed: 400,
      centerMode:true,
      autoplaySpeed:5000,
      centerPadding:'10px',
      asNavFor: '.p-topKvThumb__wrap',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '30px',
            slidesToShow: 1,
            asNavFor: '',
            dots: true,
          }
        }
      ]
    });

  }
  createSlide02(){
    const self = this;

    this.slide02 = $('.p-topKvThumb__wrap').slick({
      autoplay: true,
      slidesToShow: 2.8,
      speed: 400,
      autoplaySpeed:5000,
      asNavFor: '.p-topKvSlide__wrap'
    });
  }

};

export default TopSlider;
